import { CircularProgress } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { Button } from "react-bootstrap";
import "./styles/SecondaryButton.css";

export default function SecondaryButton({
  title,
  className,
  startIcon: StartIcon,
  endIcon: EndIcon,
  isLoading,
  isRow,
  ...props
}) {
  const [isButtonHovered, setIsButtonHovered] = useState(false);

  return (
    <Button
      onMouseEnter={() => setIsButtonHovered(true)}
      onMouseLeave={() => setIsButtonHovered(false)}
      className={`primary-button sf-secondary position-relative ${
        isLoading ? "loading-button-width" : ""
      } ${className ? className : ""}`}
      {...props}
      title='secondry'
    >
      <>
      <div className={`${isRow ? 'd-flex align-items-center justify-content-center' : ''}`}>
        {isLoading ? (
          <CircularProgress
          color="primary"
          size={21}
          thickness={7}
          className={"mr-5 loading-spinner"}
          />
          ) : null}
        {StartIcon ? <StartIcon className="start-icon" /> : null}
        {isRow && <span>{title}</span>}
      </div>
      {!isRow &&  <span>{title}</span>}
          </>
    </Button>
  );
}
